import styled from 'styled-components';
import { Button } from '../../components';
import { colors } from '../../assets/variables';
interface BoxProps {
  highlighted?: boolean;
  current?: boolean;
}

const Box = styled.div<BoxProps>`
  border-radius: 8px;
  padding: ${({ highlighted }) => (highlighted ? '16px' : '8px 16px')};
  background: ${({ highlighted }) => (highlighted ? 'white' : '#EFF5FB')};
  margin-bottom: 16px;
  display: flex;
  width: 100%;
  min-height: 92px;

  ${({ current }) =>
    current &&
    `
      border: 3px solid #21AAE8;
      animation: currentPropertyPulse 2s ease-in-out infinite;

      @keyframes currentPropertyPulse {
        0% {
          box-shadow: 0 0 0 0 rgba(33, 170, 232, 0.5);
        }

        50% {
          box-shadow: 0 0 0 6px rgba(33, 170, 232, 0.15);
        }

        100% {
          box-shadow: 0 0 0 0 rgba(33, 170, 232, 0);
        }
      }
    `}

  &.no-read {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
const NoLocationBanner = styled.div`
  background: url('https://cdn.getwaterfit.co.uk/static/files/images/no-location-bg.jpg');
  background-size: cover;
  border-radius: 8px;
  display: flex;
  padding: 16px;
  margin-bottom: 16px;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  height: 300px;
`;
const NoReadButton = styled(Button)`
  &:hover {
    background: ${colors.primary};
    color: white;
  }
`;
const DropdownWrap = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export default {
  Box,
  NoLocationBanner,
  NoReadButton,
  DropdownWrap,
};
